module.exports = __webpack_public_path__ + "img/Checkbox.f430551d.svg";